<af-main-container [title]="(userId ? 'i18n_lib_breadcrumb#UserEdit' : 'i18n_lib_breadcrumb#UserCreate') | translate"
                   [spinnerIds]="(userId || organizationId) && ['initial', 'roles', 'countries','organizations']"
                   [tabPathToTab]="tabPathToTab"
                   [customLastBreadcrumb]="organizationId
                   ? organization?.nameRu
                   : (userResponse &&
                   ('i18n_lib_breadcrumb#UserInfo' | translate :
                   {
                       fullName: [userResponse.user.lastName || '', userResponse.user.firstName || ''].join(' '),
                       email: userResponse.user.email
                   }))"
                   [specialFilter]="filterUserIdPath">
    <div fxLayout="column" class="w-100 radius-16 bc-mono-white p-24 mt-24">
        <form [formGroup]="form"
              (submit)="submit()"
              fxLayout="column"
              fxLayoutAlign="start start">
            <div class="grid-form-container">
                <div fxLayout="column" fxLayoutAlign="start start">
                    @if (form?.controls?.userType && (userTypes?.length || 0) > 1) {
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelUserType' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.userType">
                            <mat-select formControlName="userType"
                                        class="h-100"
                                        fxLayoutAlign="start center"
                                        panelClass="hide-scroll-bar"
                                        [placeholder]="'i18n_af_placeholderUserType' | translate">
                                @for (userType of userTypes; track userType) {
                                    <mat-option [value]="userType">
                                        {{ 'i18n_af_userType#' + userType | translate }}
                                    </mat-option>
                                }
                            </mat-select>
                            <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
                            @if (form.controls.userType.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    }
                </div>
                @if (form.controls.iin) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelIin' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.controls.iin.valid">
                            <input matInput
                                   [placeholder]="'i18n_af_placeholderIin' | translate"
                                   formControlName="iin"
                                   name="iin"
                                   mask="000000000000"/>
                            @if (form.controls.iin.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.iin.hasError('pattern')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationIinPattern' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.iin.hasError('maxlength')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_maxlengthError' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.lastName) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelLastName' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.lastName">
                            <input matInput
                                   formControlName="lastName"
                                   [placeholder]="'i18n_af_placeholderLastName' | translate"
                                   name="lastName"/>
                            @if (form.controls.lastName.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.lastName.hasError('maxlength')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_maxlengthError' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.firstName) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelFirstName' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.firstName">
                            <input matInput
                                   formControlName="firstName"
                                   [placeholder]="'i18n_af_placeholderFirstName' | translate"
                                   name="firstName"/>
                            @if (form.controls.firstName.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.firstName.hasError('maxlength')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_maxlengthError' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.phone && form.get('selectedPhoneInfo')) {
                    <af-phone-number
                        [control]="form.controls.phone"
                        [selectedPhoneInfoControl]="form.controls.selectedPhoneInfo"
                        [strictValidation]="!userId"
                        label="i18n_af_placeholderPhone">
                    </af-phone-number>
                }

                @if (form.controls.compositeRoles) {
                    <af-dictionary-selector
                        dictionaryName="composite_roles"
                        [control]="form.controls.compositeRoles"
                        [showCode]="true"
                        [isMultiple]="true"
                        [predefinedValue]="userResponse?.roles"
                        label="i18n_af_labelRoles"
                        placeholder="i18n_af_placeholderRoles"
                        selectedCountPlaceholder="i18n_af_placeholderRolesSelectedCount"/>
                }

                @if (form.controls.organizationType) {
                    @if (readonlyOrganization) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationType' | translate }}*</div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput readonly
                                       [value]="'i18n_af_organizationType#' + readonlyOrganization.type | translate"/>
                            </mat-form-field>
                        </div>
                    } @else {
                        <af-dictionary-selector
                            dictionaryName="binTypes"
                            [control]="form.controls.organizationType"
                            [showCode]="true"
                            [predefinedValue]="userResponse?.user?.organizationType"
                            translationPrefix="i18n_af_organizationType#"
                            label="i18n_af_labelOrganizationType"
                            placeholder="i18n_af_placeholderOrganizationType"/>
                    }
                }

                @if (form.controls.organizationBin) {
                    @if (readonlyOrganization) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelOrganizationBin' | translate }}*</div>
                            <mat-form-field class="w-100 mt-4">
                                <input matInput readonly [value]="readonlyOrganization.nameRu"/>
                            </mat-form-field>
                        </div>
                    } @else {
                        <af-dictionary-selector
                            dictionaryName="bin"
                            [control]="form.controls.organizationBin"
                            [predefinedValue]="userResponse?.user?.bin"
                            [isDependentDictionary]="true"
                            [parentDictionaryFormControl]="form.controls.organizationType"
                            label="i18n_af_labelOrganizationBin"
                            placeholder="i18n_af_placeholderOrganizationBin"/>
                    }
                }
                @if (form.controls.dnLdapName) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelDnLdap' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.dnLdapName">
                            <input matInput
                                   formControlName="dnLdapName"
                                   [placeholder]="'i18n_af_placeholderDnLdap' | translate"
                                   name="dnLdapName"/>
                            @if (form.controls.dnLdapName.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.dnLdapName.hasError('maxlength')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_maxlengthError' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.username) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelLogin' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.username">
                            <input matInput
                                   formControlName="username"
                                   [placeholder]="'i18n_af_placeholderLogin' | translate"
                                   name="username"/>
                            @if (form.controls.username.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.username.hasError('maxlength')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_maxlengthError' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.email) {
                    <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelEmail' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.email">
                            <input matInput
                                   formControlName="email"
                                   [placeholder]="'i18n_af_placeholderEmail' | translate"
                                   name="email"/>
                            @if (form.controls.email.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                            @if (form.controls.email.hasError('email')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationEmailPattern' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.enableEmailNotification) {
                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelEnableEmailNotification' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.enableEmailNotification">
                            <mat-select formControlName="enableEmailNotification"
                                        hideSingleSelectionIndicator
                                        class="h-100"
                                        fxLayoutAlign="start center"
                                        panelClass="hide-scroll-bar"
                                        [placeholder]="'i18n_af_placeholderEnableEmailNotification' | translate">
                                <mat-option [value]="true">{{ 'i18n_af_labelYes'| translate }}</mat-option>
                                <mat-option [value]="false">{{ 'i18n_af_labelNo'| translate }}</mat-option>
                            </mat-select>
                            <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
                            @if (form.controls.enableEmailNotification.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
                @if (form.controls.enableUacAccess) {
                    <div fxLayout="column" fxLayoutAlign="start start">
                        <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelEnableUnitedAntiFraudCenterAccess' | translate }}*</div>
                        <mat-form-field class="w-100 mt-4"
                                        [class.value-not-empty]="form.value.enableUacAccess">
                            <mat-select formControlName="enableUacAccess"
                                        hideSingleSelectionIndicator
                                        class="h-100"
                                        fxLayoutAlign="start center"
                                        panelClass="hide-scroll-bar"
                                        [placeholder]="'i18n_af_placeholderEnableUnitedAntiFraudCenterAccess' | translate">
                                <mat-option [value]="true">{{ 'i18n_af_labelYes'| translate }}</mat-option>
                                <mat-option [value]="false">{{ 'i18n_af_labelNo'| translate }}</mat-option>
                            </mat-select>
                            <ui-kit-svg matSuffix class="i-16 mr-16 pointer c-primary-gray-600" name="ic_arrow_down"/>
                            @if (form.controls.enableUacAccess.hasError('required')) {
                                <mat-error
                                    class="c-secondary-red-900">
                                    {{ 'i18n_af_fieldValidationRequired' | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                    </div>
                }
            </div>
            @if (!!form.controls.userType.value) {
                <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                    <ui-kit-button spinnerId="submit"
                                   [disabled]="form.invalid"
                                   [label]="'i18n_af_buttonSave' | translate"/>
                    <ui-kit-button class="ml-16"
                                   color="accent"
                                   buttonType="button"
                                   type="text"
                                   (clickListener)="navigateBack()"
                                   [label]="'i18n_af_buttonCancel' | translate"/>
                </div>
            }
        </form>
    </div>
</af-main-container>
